import React, { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getCategoryBySlug, mapToNewCategory } from '../data/categories';
import { products } from '../data/productsData';
import './CategoryPage.css';

const CategoryPage = () => {
    const { slug } = useParams();
    const category = getCategoryBySlug(slug);

    // Filter products by category
    const categoryProducts = useMemo(() => {
        if (!category) return [];
        return products.filter(product => {
            const productCategorySlug = mapToNewCategory(product.category);
            return productCategorySlug === slug;
        });
    }, [category, slug]);

    // Get price display
    const getPrice = (product) => {
        if (product.type === 'single') {
            return `₹${product.price}`;
        } else if (product.variants && product.variants.length > 0) {
            const prices = product.variants.map(v => v.price);
            const minPrice = Math.min(...prices);
            const maxPrice = Math.max(...prices);
            return minPrice === maxPrice ? `₹${minPrice}` : `₹${minPrice} - ₹${maxPrice}`;
        } else if (product.sizes && product.sizes.length > 0) {
            const prices = product.sizes.map(s => s.price);
            const minPrice = Math.min(...prices);
            const maxPrice = Math.max(...prices);
            return minPrice === maxPrice ? `₹${minPrice}` : `₹${minPrice} - ₹${maxPrice}`;
        }
        return '';
    };

    if (!category) {
        return (
            <div className="category-page">
                <div className="category-not-found">
                    <h2>Category not found</h2>
                    <Link to="/" className="back-link">← Back to Home</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="category-page">
            {/* Breadcrumb */}
            <div className="category-breadcrumb">
                <Link to="/">Home</Link>
                <span className="breadcrumb-separator">/</span>
                <span className="breadcrumb-current">{category.name}</span>
            </div>

            {/* Category Header */}
            <div className="category-header">
                <div className="category-header-icon">{category.icon}</div>
                <div className="category-header-info">
                    <h1 className="category-title">{category.name}</h1>
                    <p className="category-description">{category.description}</p>
                    <span className="category-count">{categoryProducts.length} Products</span>
                </div>
            </div>

            {/* Products Grid */}
            {categoryProducts.length > 0 ? (
                <div className="category-products-grid">
                    {categoryProducts.map((product) => (
                        <Link
                            key={product.id}
                            to={`/product/${product.slug}`}
                            className="category-product-card"
                        >
                            <div className="category-product-image">
                                <img
                                    src={product.image}
                                    alt={product.name}
                                    loading="lazy"
                                />
                            </div>
                            <div className="category-product-info">
                                <h3 className="category-product-name">{product.name}</h3>
                                <p className="category-product-desc">{product.shortDescription}</p>
                                <span className="category-product-price">{getPrice(product)}</span>
                            </div>
                        </Link>
                    ))}
                </div>
            ) : (
                <div className="category-empty">
                    <p>No products in this category yet.</p>
                    <p>Check back soon!</p>
                </div>
            )}
        </div>
    );
};

export default CategoryPage;
